import React, { useEffect } from 'react';
import JsonInputField from '../../../../../Utility/JsonInputField/JsonInputField';
import Input from '../../../../../Utility/FormElements/Input';

interface ArgumentsEditorProps {
    title: string;
    value: string;
    onChange: (v: string) => void;
    placeholder?: string;
    isValid?: boolean;
    errorText?: string | null;
    schema?: any;
    setCanExecute: React.Dispatch<React.SetStateAction<boolean>>;
}

const ArgumentsEditor: React.FC<ArgumentsEditorProps> = ({
    title,
    value,
    onChange,
    placeholder,
    isValid = true,
    errorText,
    schema,
    setCanExecute,
}) => {
    const [allValues, setAllValues] = React.useState<Record<string, any>>(
        value && value.trim() !== '' ? JSON.parse(value) : {},
    );

    useEffect(() => {
        const checkRequiredFields = () => {
            if (!schema?.required || !Array.isArray(schema.required)) {
                setCanExecute(true);
                return;
            }

            const hasAllRequiredFields = schema.required.every((requiredKey: string) => {
                if (!(requiredKey in allValues)) {
                    return false;
                }

                const value = allValues[requiredKey];
                const fieldSchema = schema.properties?.[requiredKey];

                if (value === null || value === '') {
                    return false;
                }

                if (fieldSchema?.type === 'number' && isNaN(value)) {
                    return false;
                }

                return true;
            });

            setCanExecute(hasAllRequiredFields);
        };

        checkRequiredFields();
    }, [allValues, schema, setCanExecute]);

    return (
        <div>
            {schema?.properties &&
                Object.entries(schema.properties).map(([key, schemaItem]: [string, any]) => (
                    <div key={key}>
                        <label className="flex flex-col gap-2 text-sm mb-3">
                            {schemaItem.description} {schema.required?.includes(key) && '*'}
                            <Input
                                inputType={schemaItem.type === 'number' ? 'number' : 'text'}
                                value={allValues[key] === undefined ? '' : String(allValues[key])}
                                onChange={(value) => {
                                    let updatedValue = {
                                        ...allValues,
                                    };

                                    if (value === '') {
                                        delete updatedValue[key];
                                    } else {
                                        updatedValue[key] = schemaItem.type === 'number' ? Number(value) : value;
                                    }

                                    setAllValues(updatedValue);
                                    onChange(JSON.stringify(updatedValue));
                                }}
                                placeholder={schemaItem.description || placeholder}
                                className="w-full"
                            />
                        </label>
                    </div>
                ))}
            {!isValid && errorText && <p className="text-red-500 text-sm mt-2">{errorText}</p>}
        </div>
    );
};

export default ArgumentsEditor;
